export default __webpack_public_path__ + "assets/images/486cddcddb650e922a3a43f37e548dab.png";